import React, { useContext } from 'react';
import AddToCartButtons from '../AddToCart/AddToCartButtons.jsx';
import { Voucher } from '../../services/Constants/ObjectDefinitions.js';
import PropTypeShapes from '../../services/Constants/PropTypeShapes.jsx';
import PropTypes from 'prop-types';
import StockStatus from '../../services/Constants/StockStatus.js';
import { SubscriptionDetailsContext } from '../../services/context/SubscriptionDetailsContext.js';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import { LimitsContext } from '../../services/context/LimitsContext.js';
import { CartContext } from '../../services/context/CartContext.js';
import { getVoucherLimitInfo } from '../../services/utils/vendorLimits.js';
import { MoneyFormatterContext } from '../../services/context/MoneyFormatterContext.js';
import { EligibilityContext } from '../../services/context/EligibilityContext.js';
import { createIsAdvanceOptionFilter } from '../../services/EligibilityOffers.js';
/**
 * @param {object} props - the props of the component
 * @param {Voucher} props.voucher - the voucher to check
 * @param {JSX.Element} props.isClubVoucher - vodapay club voucher check
 * @returns {JSX.Element} StockChecker component
 */
export default function StockChecker({ voucher, isClubVoucher = false }) {
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const limits = useContext(LimitsContext);
  const cart = useContext(CartContext);
  const navigateTo = useNavigate();
  const { expiryDate, isSubscribed, isEligibleToSubscribe } = subscriptionDetails || {};

  const MoneyFormatter = useContext(MoneyFormatterContext);
  const eligibility = useContext(EligibilityContext);

  // Check voucher is advance voucher or not and pass the info to getVoucherLimitInfo
  const isAdvance = voucher => {
    const isAdvanceOption = createIsAdvanceOptionFilter(
      eligibility,
      voucher,
      MoneyFormatter,
    );
    return Boolean(voucher?.options?.advance.terms.options?.some(option => isAdvanceOption(option)));
  };

  const { isPurchased } = getVoucherLimitInfo(limits, voucher?.id, cart, isAdvance);

  // Helper function to handle the club voucher logic
  const shouldDisplayClubButton = () => expiryDate && !isSubscribed && isEligibleToSubscribe;

  const shouldDisplayAddToCart = () => {
    const isInStock = voucher.stock.status === StockStatus.inStock && !isPurchased;
    if (isClubVoucher) {
      return isSubscribed && voucher.stock.status === StockStatus.inStock && !isPurchased;
    }

    return isInStock;
  };

  // Handle club voucher case
  if (isClubVoucher) {
    if (shouldDisplayClubButton()) {
      return (
        <button
          className='secondary-button'
          onClick={ () => navigateTo(ROUTES.VODAPAY_CLUB) }
        >
          Join the club
        </button>
      );
    }

    if (!expiryDate && !isSubscribed) {
      return null;
    }
  }

  if (shouldDisplayAddToCart()) {
    return <AddToCartButtons voucher={ voucher } />;
  }

  // If it's out of stock OR the subscriber limit is exhausted
  const isOutOfStock = voucher.stock.status !== StockStatus.inStock || isPurchased;
  return <> {isOutOfStock ? 'Out of stock' : null} </>;
}

StockChecker.propTypes = {
  voucher: PropTypeShapes.voucher,
  isClubVoucher: PropTypes.bool,
};
